import { Component, Injector, Input, OnInit, ViewChild, output, input, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { entityState, entityStateName } from '../../services/jkEntityTypes';

@Component({
  selector: 'app-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatToolbar,
    MatIcon,
  ],
})
export class ModalHeaderComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'modal-header';
  readonly onOkClick = output();
  readonly onCancelClick = output();
  _state: entityState = entityState.dsBrowse;
  readonly onUpdateClick = output(); // TODO:
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set state(st: entityState) {
    this._state = st;
  }
  get stateName(): string {
    return entityStateName(this._state);
  }
  get updateVisible(): boolean {
    return this._state === entityState.dsEdit;
  }
  readonly cancelVisible = input<boolean>(true);
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  set title(t: string) {
    this.label.set(t);
  }
  readonly onUser1Click = output(); //: EventEmitter<any>;
  readonly onUser2Click = output(); //: EventEmitter<any>;
  readonly isDialog = input<boolean>(true);
  readonly user1Text = input<string>('');
  readonly user2Text = input<string>('');
  readonly user1Visible = input<boolean>(false);
  readonly user2Visible = input<boolean>(false);
  readonly onEditAndSaveClick = output(); //: EventEmitter<any>;

  constructor() {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    if (this.label() === '') {
      this.label.set('modal-header標題未設定');
    };

    this.initVisible();
  }
  initVisible() {
    /*if(this.onUser1Click){
      this.user1Visible = true;
    }
    if(this.onUser2Click){
      this.user2Visible = true;
    }*/
  }
  doUpdate(e: any) {
    this.onUpdateClick.emit(e);
  }
  doOk(e: any) {
    this.onOkClick.emit(e);
  }
  doCancel(e: any) {
    this.onCancelClick.emit(e);
    //this.onCancelClick(e);
  }
  doUser1(e: any) {
    this.onUser1Click.emit(e);
  }
  doUser2(e: any) {
    this.onUser2Click.emit(e);
  }
  async doEditAndSave($event: any) {
    this.onEditAndSaveClick.emit($event);
  }

}
